import Vue from "vue";
import App from "./javascript/App.vue";
import VueAgile from "vue-agile";
import router from "./router";
import store from "./store";
import translations from "./translations";
import { formatBRL, formatBRLDec, formatCNPJ } from "./javascript/utilities";
import VueHead from 'vue-head';

import focus from './plugins/focus';

Vue.filter("officeName", key => {
	switch (key) {
		case 1:
			return "Prefeito";
			break;
		case 2:
			return "Vereador";
			break;
		case 3:
			return "Vice-prefeito";
			break;
		case 4:
			return "Presidente";
			break;
		case 5:
			return "Senador";
			break;
		case 6:
			return "Governador";
			break;
		case 7:
			return "Deputado Estadual";
			break;
		case 8:
			return "Deputado Federal";
			break;
		case 9:
			return "Deputado Distrital";
			break;
		default:
			break;
	}
});

Vue.filter("sentenceCase", value => {
	if (!value) return "";
	return (
		value
			.toString()
			.charAt(0)
			.toUpperCase() + value.toString().slice(1)
	);
});

Vue.filter("lowerCase", value => value.toLowerCase());

Vue.filter("upperCase", value => value.toUpperCase());

Vue.filter('titleCase', str =>
  str
    .split(/\s+/)
    .map((item) => {
      if (item.length > 2) {
        if (item.toLowerCase() === 'dos') {
          return item.toLowerCase();
        }
        return item.charAt(0).toUpperCase() + item.substring(1).toLowerCase();
      }
      return item.toLowerCase();
    })
    .join(' '));

Vue.filter('date', (value) => {
	if (!value) return;
	const newDate = new Date(value.replace(' ', 'T'));
	return `${(newDate.getDate() <= 9) ? `0${newDate.getDate()}` : newDate.getDate()}/${((newDate.getMonth() + 1) <= 9) ? `0${(newDate.getMonth() + 1)}` : (newDate.getMonth() + 1)}/${newDate.getFullYear()} - ${(newDate.getHours() <= 9) ? `0${newDate.getHours()}` : newDate.getHours()}:${(newDate.getUTCMinutes() <= 9) ? `0${newDate.getUTCMinutes()}` : newDate.getUTCMinutes()}`;
});

Vue.filter('formatCPF', (value) => {
	return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
});
Vue.filter("formatCNPJ", formatCNPJ);

Vue.filter("formatBRL", formatBRL);
Vue.filter("formatBRLDec", formatBRLDec);

Vue.use(focus);

Vue.use(VueHead);
Vue.use(VueAgile);

new Vue({
	el: "#app",
	router,
	store,
	translations,
	data() {
		return {
			currentRoute: window.location.pathname
		};
	},
	render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./_source/main.js